/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ReqCreateBadge = {
    name: string;
    description: string;
    iconUrl: string;
    type: ReqCreateBadge.type;
};
export namespace ReqCreateBadge {
    export enum type {
        NORMAL = 'NORMAL',
        SPECIAL = 'SPECIAL',
    }
}

